import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AccordionFirstChild from './AccordionFirstChild';

const AccordionInnerItem = ({
  data = {},
  findObjectAndUpdate,
  twoYrBackData,
  contractEnd,
}) => {
  return (
    <Fragment>
      {data.nodes &&
        data.nodes.map(child => {
          return (
            <AccordionFirstChild
              key={child.optionId}
              twoYrBackData={twoYrBackData}
              contractEnd={contractEnd}
              child={child}
              findObjectAndUpdate={findObjectAndUpdate}
              data={data}
              maxHistoricalData={data.historicalData}
              hidden={child.hidden}
            />
          );
        })}
    </Fragment>
  );
};
AccordionInnerItem.propTypes = {
  data: PropTypes.shape({}),
  findObjectAndUpdate: PropTypes.func,
  twoYrBackData: PropTypes.bool,
  contractEnd: PropTypes.string,
};
export default React.memo(AccordionInnerItem);
